function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function admCookie(cookiesListeServices) {
  var cookiesT = cookiesListeServices.split(","),
    tarteCookie = window.tarteaucitron.cookie.read();

  cookiesT.forEach(function (cookieString) {
    if (tarteCookie !== '')
    {
      if (tarteCookie.indexOf(cookieString+"=wait"))
      {
        window.tarteaucitron.cookie.create(cookieString, true);
      }
      else if (tarteCookie.indexOf(cookieString+"=false"))
      {
        window.tarteaucitron.cookie.create(cookieString, false);
      }
      else if (tarteCookie.indexOf(cookieString+"=true"))
      {
      }
    }
    else
    {
      window.tarteaucitron.cookie.create(cookieString, true);
    }
  });
}

(function ($) {
  "use strict";

  $(window).on("load", function () {

    var interval = setInterval(function () {

      if($("#block-bandeauflottantblock").length > 0){
        var bandeauFlottantSize = $("#block-bandeauflottantblock").height()
        if($("#tarteaucitronAlertBig").length){
          $("#tarteaucitronAlertBig").css('bottom',bandeauFlottantSize+'px')
        }

      }

      if ($('#tarteaucitronRoot').length > 0) {
        /* allow google manager */
        if(getCookie("meringuee") === "") {
          admCookie("googletagmanager");
          setCookie("meringuee", 1, 365);
        }

        /*override tarteaucitron (bouton personnaliser + scroll)*/
        var tarteCookie = window.tarteaucitron.cookie.read();
        $('#tarteaucitronCloseAlert').removeAttr('onclick');
        $(window).removeAttr('scroll');
        $(document).on('click', function (evt) {
          if ($(evt.target).is('#tarteaucitronCloseAlert')) {
            $('#tarteaucitronAlertBig').css("display", "none");
            location.pathname = "/en-savoir-plus-sur-les-cookies";
          }
          else if ($(evt.target).is('#tarteaucitronPersonalize')) {
            // $('.testDisplay').css("display", "none");
          }
          else if ($(evt.target).is('#tarteaucitronCloseAlert')) {

          }
          else if ($(evt.target).is('#tarteaucitronAllAllowed') || $(evt.target).is('.tarteaucitronAllow')) {
            $('#tarteaucitronAllDenied').css("background-color", "gray");
          }
          else if ($(evt.target).is('#tarteaucitronAllDenied') || $(evt.target).is('.tarteaucitronDeny')) {
            $('#tarteaucitronAllAllowed').css("background-color", "gray");
          }
          else {
            $(window).on("unload", function () {
              if (tarteCookie.indexOf("=wait") > 0 && location.pathname !== "/en-savoir-plus-sur-les-cookies") {
                window.tarteaucitron.userInterface.respondAll(true);
              }
            });
          }
        });

        var hasScroll = false;
        $(document).on('scroll', function () {
          if(hasScroll === false && $(window).scrollTop() + $(window).height() === $(document).height()){
            window.tarteaucitron.userInterface.respondAll(true);
            hasScroll = true;
          }
        });

        clearInterval(interval);
      }
      else {
        return;
      }
    }, 500);

    if (top.location.pathname === '/en-savoir-plus-sur-les-cookies') {
      $('.manageCookies').click(function () {
        window.tarteaucitron.userInterface.openPanel();
        $('#tarteaucitronInfo').remove();
        $('#dialogTitle').remove();

        $('.tarteaucitronName').first().empty();

        $('.tarteaucitronName').first().append("<b id='tacTitle' class='tarteaucitronTitle' ><a class='clickme'>✛</a> Préférence pour tous les services</b>");
        $('.clickme').on("click", function () {
          if ($('#tacInfo').hasClass('appeared')){
            $('#tacInfo').removeClass('appeared');
          }
          else {
            $('#tacInfo').addClass('appeared');
          }
        });
        $("#tarteaucitronMainLineOffset").after("<div id=\"tacInfo\" class=\"tarteaucitronInfoBox tarteaucitronDetails\">" + window.tarteaucitron.lang.disclaimer + "</div>");

      });

    }
  });

})(jQuery);

